/* ControlNode — Custom React Flow node for control type (e.g. delay) */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import css from '../../AutomationEditor.module.css';
import NodeIcon from './NodeIcon';

export default memo(function ControlNode({ data, selected }: NodeProps) {
  const color = (data.color as string) || '#95a5a6';

  return (
    <div
      className={`${css.customNode}${selected ? ` ${css.selected}` : ''}`}
      style={{ borderColor: color }}
    >
      <div className={css.nodeHeader}>
        <div className={css.nodeIcon} style={{ background: color }}>
          <NodeIcon icon={(data.icon as string) || '⏱'} />
        </div>
        <div>
          <div className={css.nodeLabel}>{data.label as string}</div>
          <div className={css.nodeType}>Control</div>
        </div>
      </div>
      <Handle type="target" position={Position.Top} id="default" />
      <Handle type="source" position={Position.Bottom} id="default" />
    </div>
  );
});
